module.exports = __webpack_public_path__ + "static/media/ic_empty_image.eeb7b733.png";